import { createAsyncThunk, createSlice, isFulfilled, isPending, isRejected, createSelector } from "@reduxjs/toolkit"
import * as service from './service'
import { RootState } from "../../../redux/store"
import { Customer, Task, TaskLog } from './types'

const SLICE_PREFIX = 'tasks'
export type LoadingState = 'not-asked' | 'loading' | 'done' | 'error'

interface State {
  customer: Customer | null
  loadingState: LoadingState
  tasks: Task[] | null
}

const initialState: State = {
  customer: null,
  tasks: null,
  loadingState: 'not-asked',
}

export const getPracticeTasks = createAsyncThunk(
  `${SLICE_PREFIX}/getCustomerTasks`,
  async (customerNumber: string) => {
    const includeLogs = true
    const tasks = await service.getTasks(customerNumber, includeLogs)
    return { customerNumber, tasks }
  }
)

export const taskSlice = createSlice({
  name: SLICE_PREFIX,
  initialState,
  reducers: {
    clearPracticeTasks: () => {
      return initialState
    },
  },
  extraReducers(builder) {
    builder.addMatcher(isPending(getPracticeTasks), (state) => {
      state.loadingState = 'loading'
    })

    builder.addMatcher(isRejected(getPracticeTasks), (state) => {
      state.loadingState = 'error'
    })

    builder.addMatcher(isFulfilled(getPracticeTasks), (state, { payload }) => {
      state.loadingState = 'done'

      state.customer = { customer_number: payload.customerNumber }
      state.tasks = payload.tasks
    })
  }
})

export const { clearPracticeTasks } = taskSlice.actions

export const selectCustomer = (state: RootState) => state.tasks.customer
export const selectLoadingState = (state: RootState) => state.tasks.loadingState
export const selectTasks = (state: RootState) => state.tasks.tasks

export const selectTaskLogs = createSelector(
  selectTasks,
  (tasks: Task[] | null) => {
    const taskLogs: TaskLog[] = (tasks ?? [])
      .flatMap(task => task.task_logs ?? [])

    return taskLogs
  }
)

export default taskSlice.reducer